import { makeStyles } from "@material-ui/core/styles";

export const textStyles = makeStyles({
  root: {
    color: "black"
  },
  testCardText: {
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    fontSize: "14px !important"
  },
  italics: {
    fontStyle: "italic"
  },
  bold: {
    fontWeight: "bold !important"
  },
  testCardYearText: {
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    fontSize: "20px !important"
  },
  homeDeckCardsText: {
    textTransform: "uppercase !important",
    fontSize: ".9rem !important",
    marginBottom: "0px !important",
    overflow: "hidden",
    textOverflow: "ellipsis !important"
  }
});
